import { fetchJson } from "../lib/api";

export type OrderRow = {
  order_key: string;
  order_number: string | null;
  order_date: string | null;
  supplier: string | null;
  primary_doc_id: string | null;
  primary_doc_number: string | null;
  primary_doc_type: string | null;
  pdf_order_doc_id: string | null;
  pdf_order_doc_number: string | null;
  pdf_invoice_doc_id: string | null;
  pdf_invoice_doc_number: string | null;
  buyer_email: string | null;
  buyer_name: string | null;
  project_key: string | null;
  project_count: number | null;
  delivery_address_key: string | null;
  delivery_address_display: string | null;
  delivery_is_warehouse: boolean | null;
  delivery_address_count: number | null;
  customer_reference: string | null;
  customer_reference_count: number | null;
  line_count: number | string | null;
  article_count: number | string | null;
  total_expenses: number | string | null;
  order_line_count: number | string | null;
  invoice_line_count: number | string | null;
  ugl_line_count: number | string | null;
  has_pdf_order_evidence: boolean;
  has_pdf_invoice_evidence: boolean;
  has_ugl_evidence: boolean;
  has_invoice_order_match: boolean;
  has_cost_center_context: boolean;
  reconciliation_state: string | null;
  line_reconciliation_state: string | null;
  cost_center_state: string | null;
  source_summary: string | null;
};

export type OrderDetailLine = {
  source_kind: "pdf_rechnung" | "pdf_auftrag" | "ugl_rechnung" | "ugl_vorgang";
  document_id: string | null;
  document_type: string | null;
  document_number: string | null;
  document_date: string | null;
  line_pos: string | number | null;
  primary_article_code: string | null;
  article_group_key: string | null;
  description: string | null;
  qty: string | number | null;
  uom: string | null;
  list_unit_price: string | number | null;
  discount_pct: string | number | null;
  net_unit_price: string | number | null;
  effective_unit_price: string | number | null;
  line_net_amount: string | number | null;
  page_no: string | number | null;
  pdf_doc_id: string | null;
  project_key: string | null;
  delivery_address_key: string | null;
  delivery_address_display: string | null;
  delivery_is_warehouse: boolean | null;
  buyer_email: string | null;
  buyer_name: string | null;
  source_file: string | null;
  source_record_row: string | number | null;
  raw_record: string | null;
};

export type OrderDetailResponse = {
  order: OrderRow;
  lines: OrderDetailLine[];
  line_total: number;
};

export async function fetchOrderDetail(
  orderKey: string,
): Promise<OrderDetailResponse> {
  return fetchJson<OrderDetailResponse>(
    `/api/orders/${encodeURIComponent(orderKey)}`,
  );
}
